<!--  -->
<template>
  <div>
    <div class="cont_r_b11">
      <p>
        <img :src="images.xxzj" alt>
      </p>
      <p>
        <br>
      </p>
      <p>
        <b>
          <span style="font-size:16.0pt;font-family:宋体;">Planetary Rolling Mill</span>
        </b>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: {
        xxzj: require("../../../assets/img/common/xxzj.jpg")
      }
    };
  },

  components: {},
  methods: {}
};
</script>
<style lang='stylus' rel='stylesheet/stylus'>
</style>


// WEBPACK FOOTER //
// src/components/en/device/xxzj.vue